import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';

export class VarianceFilter extends FilterBase {
  makeIndex(): any {
    return new PourOver.makeContinuousRangeFilter('variance');
  }

  getMatchSet(collection: any, filterSettings): any {
    if (filterSettings.variance > 0) {
      return collection.filters.variance.getFn([
        filterSettings.variance,
        1000000
      ]);
    }
  }

  getCounts(): any {
    return {};
  }
}
